
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goodtrust-life",
      function () {
        return require("private-next-pages/goodtrust-life.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goodtrust-life"])
      });
    }
  